import { MiniSparkline } from '@/components/charts/MiniSparkline';
import { TrendBadge } from '@/components/common/TrendBadge';

export const KpiCard = ({ label, value, icon: Icon, trend, trendTooltip, comparison, spark = [], invertTrend = false, footer, accent = false }) => (
  <div className="group relative overflow-hidden rounded-2xl border bg-card p-4 card-shadow transition-shadow duration-200 hover:card-shadow-lg lg:p-5" data-testid="kpi-card">
    {accent && <span className="absolute left-0 top-0 h-full w-1" style={{ background: 'var(--tenant-accent-500)' }} />}
    <div className="flex items-start justify-between gap-3">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl accent-bg-100">
        {Icon && <Icon className="h-5 w-5 accent-text" />}
      </div>
      {trend !== undefined && <TrendBadge value={trend} invert={invertTrend} tooltip={trendTooltip} testid="kpi-card-trend" />}
    </div>
    <p className="mt-3 text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
    <p className="mt-1 kpi-value text-2xl md:text-3xl text-foreground" data-testid="kpi-card-value">{value}</p>
    {comparison && <p className="mt-0.5 text-xs text-muted-foreground">{comparison}</p>}
    {spark.length > 0 && <div className="mt-3"><MiniSparkline data={spark} /></div>}
    {footer && <div className="mt-2">{footer}</div>}
  </div>
);
